import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getEligibleBinCount = {
  name: "getEligibleBinCount" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ eligibleBinCount: z.number().int().nonnegative() }),
};
